import utils from '../utils';

export default function tallyAggregates(summary, locationIds, sales, schemaFields) {
  const result = {};

  const breakdownByLocationFields = schemaFields.filter(
    ({ calculateOnAggregated, breakdownByLocation }) =>
      !calculateOnAggregated && breakdownByLocation
  );
  const getByLocationCtx = (locationId) =>
    breakdownByLocationFields.reduce((agg, item) => {
      agg[item.originalFieldName] = summary[item.fieldName][locationId];
      return agg;
    }, {});

  schemaFields
    .filter(({ calculateOnAggregated }) => calculateOnAggregated)
    .forEach(({ formula, fieldName, breakdownByLocation }) => {
      if (breakdownByLocation) {
        result[fieldName] = locationIds.reduce((agg, locationId) => {
          agg[locationId] = utils.evaluateExpression(formula, {
            ...getByLocationCtx(locationId),
            sales: sales.byLocation[locationId],
          });

          return agg;
        }, {});
      } else {
        result[fieldName] = utils.evaluateExpression(formula, {
          ...summary,
          sales: sales.total,
        });
      }
    });

  return result;
}
